import { Injectable } from "@angular/core";
import { UrlServidor } from "../util/url-servidor";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Patrimonio } from "../api/dto/patrimonio";
import { Observable } from "rxjs";
import { PageResponse } from "../api/dto/paginacao/page-response";

@Injectable({
    providedIn: "root",
})
export class PatrimonioService {
    private url: string = UrlServidor.URL_BASE + "patrimonios";

    constructor(private http: HttpClient) { }

    buscarPorId(patrimonioId: number): Observable<Patrimonio> {
        return this.http.get<Patrimonio>(`${this.url}/${patrimonioId}`);
    }

    listarPorEmpresa(
        empresaId: number,
        page: number,
        size: number,
        sort: string,
        busca?: string,
        situacao?: string
    ): Observable<PageResponse<Patrimonio>> {
        let params = new HttpParams()
            .set("page", page)
            .set("size", size)
            .set("sort", sort);

        if (busca) {
            params = params.set("busca", busca);
        }

        if (situacao) {
            params = params.set("situacao", situacao);
        }

        return this.http.get<PageResponse<Patrimonio>>(`${this.url}/empresa/${empresaId}`, { params });
    }

    salvar(patrimonio: Patrimonio): Observable<Patrimonio> {
        return this.http.post<Patrimonio>(this.url, patrimonio);
    }

    atualizar(patrimonioId: number, patrimonio: Patrimonio): Observable<Patrimonio> {
        return this.http.put<Patrimonio>(`${this.url}/${patrimonioId}`, patrimonio);
    }

    excluir(patrimonioId: number): Observable<void> {
        return this.http.delete<void>(`${this.url}/${patrimonioId}`)
    }
}
